import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromAuth from './auth.reducer';
import { AuthEffects } from './auth.effects';
import { SharedConfig, SHARED_CONFIG } from '@emi/shared/models';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromAuth.feature.name, fromAuth.feature.reducer),
    EffectsModule.forFeature([AuthEffects])
  ],
})
export class SharedStateAuthModule {
  static forRoot(config: SharedConfig): ModuleWithProviders<SharedStateAuthModule> {
    return {
      ngModule: SharedStateAuthModule,
      providers: [
        {
          provide: SHARED_CONFIG,
          useValue: config,
        },
      ],
    };
  }
}